import { render, staticRenderFns } from "./users-table.vue?vue&type=template&id=4f39481d"
import script from "./users-table.vue?vue&type=script&lang=js"
export * from "./users-table.vue?vue&type=script&lang=js"
import style0 from "./users-table.vue?vue&type=style&index=0&id=4f39481d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports